<template>
  <div>
    <useTable
      :searchForm="searchForm"
      :httprequest="httprequest"
      ref="useTable"
      :headerList="headerData"
    ></useTable>

    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="500px"
      center
    >
      <span>确认{{toolsInfo.name}}吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfrimClick"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <editInventory v-model="editInventoryObj.showPop" :detail="editInventoryObj.detail" @sureEdit="sureEditInventory"></editInventory>
    <!-- 课程预览弹窗 -->
    <el-dialog title="课程预览" :visible.sync="coursePreviewObj.showPop" width="664px" height="400px">
        <div class="qrcode" style=" width:200px; margin:0 auto; margin-bottom:10px;">
            <img :src="coursePreviewObj.img" style="height: 200px;" alt="">
        </div>
        <p style="width: 100%;text-align: center;">打开小红书app扫一扫</p>
    </el-dialog>
  </div>
</template>
<script>
import useTable from "@/components/useTable/useTable.vue";
import editInventory from './components/editInventory.vue'
import { mapActions } from "vuex";
import courseInfo from "./components/courseInfo/courseInfo.vue";
export default {
  data() {
    
    const statusList = [
      {
        label: "全部",
        value: "",
      },
      {
        label: "已上架",
        value: 1,
      },
      {
        label: "已下架",
        value: 2,
      },
    ];
    const editStatusObj = { // 编辑状态
      '2': {
        label: '审核中'
      },
      '3': {
        label: '审核失败'
      },
      '4': {
        label: '审核成功'
      }
    }
    const statusObj = { // 上下架状态
      '1': {
        label: '已上架',
        class: ''
      },
      '2': {
        label: '已下架',
        class: 'status_name2'
      },
    }
    return {
      classNames: "courseList",
      centerDialogVisible:false,
      toolsInfo:{},
      editInventoryObj: {
        showPop: false,// 展示设置库存弹窗
        detail: {}
      },
      coursePreviewObj: { // 预览课程相关
        showPop: false,
        img: 'https://pic.3gbizhi.com/uploads/20240402/4c71016e249dcad5b07fbf09a398250a.jpg'
      },
      headerData: [
        {
          props: {
            type: "index",
            width: 60,
          },
          render: (h, scope) => {
            return <span>{scope.$index + 1}</span>;
          },
        },
        {
          props: {
            prop: "type_fomat",
            label: "课程",
            width: 300,
          },
          render: (h, scope) => {
            return (
              <div>
                <courseInfo
                  content={{
                    cover: JSON.parse(scope.row.images)[0] ,
                    title: scope.row.title,
                    price: scope.row.price,
                    time: scope.row.created_time,
                  }}
                  coverInfo='width: 82px;height: 82px;'
                ></courseInfo>
              </div>
            );
          },
        },
        {
          props: {
            prop: "",
            label: "状态",
            width: 300,
            'show-overflow-tooltip': true,
          },
          render: (h, scope) => {
            return (
              <div class="course_status">
                <div class="top">
                  {scope.row.status && (
                    <div class={['status_name',statusObj[scope.row.status].class]}>{statusObj[scope.row.status].label }</div>
                  )}
                  {scope.row.reject_text && (
                    <div class="reject">
                      <span class="reason">驳回原因: {scope.row.reject_text}</span>
                    </div>
                  )}
                </div>
                {scope.row.edit_status && (
                  <div class="edit_staus">{editStatusObj[scope.row.edit_status].label }</div>
                )}
              </div>
            );
          },
        },
        {
          props: {
            prop: "",
            label: "销量",
          },
          render: (h, scope) => {
            return <div>{scope.row.sales}</div>;
          },
        },
        {
          props: {
            prop: "",
            label: "库存",
            width: 120
          },
          render: (h, scope) => {
            return (
              <div style="display:flex;align-items:center;">
                <div class="title-text">
                  { scope.row.stock }
                </div>  
                <i onClick={this.changeInventory.bind(this, scope.row)} style="cursor:pointer; margin-left:10px;" class="el-icon-edit-outline compile-icon">
                </i>
              </div>
            )
          },
        },
        {
          props: {
            prop: "is_call_des",
            label: "操作",
            width: 100,
            fixed: 'right'
          },
          render: (h, scope) => {
              return (
                <div class="button_warp">
                  {(scope.row.status == 2 && scope.row.edit_status == 4) &&
                    (
                      <div
                        class="line_button"
                        onClick={this.handleTools.bind(this, scope.row.id,'classGroundingAPI','上架',{status:1})}
                      >
                        上架
                      </div>
                  )}
                  {scope.row.status == 1 && (
                    <div
                      class="line_button"
                      onClick={this.handleTools.bind(this, scope.row.id,'classGroundingAPI','下架',{status:2})}
                    >
                      下架
                    </div>
                  )}
                  {scope.row.edit_status != 2  && (
                    <div
                      class="line_button"
                      onClick={this.handleTools.bind(this, scope.row.id,'editCourse','编辑')}
                    >
                      编辑
                    </div>
                  )}
                  {/* {scope.row.edit_status == 2 && (
                    <div
                      class="line_button"
                      onClick={this.handleTools.bind(this, scope.row.id,'','撤回')}
                    >
                      撤回
                    </div>
                  )} */}
                  {/* {true && (
                    <div
                      class="line_button"
                      onClick={this.handleTools.bind(this, scope.row.id,'preview','预览')}
                    >
                      预览
                    </div>
                  )} */}
                </div>
              );  
          },
        },
      ],
      searchForm: [
        {
          Component: "el-button",
          span: 3,
          componentProps: {
            type: "primary",
          },
          renderHTML: () => {
            return "新建课程";
          },
          on: {
            click: this.addCourse,
          },
          // afterslot: () => {
          //   return (
          //     <a
          //       style="color:#1989fa;margin-left: 12px;cursor:pointer;font-size:14px;text-decoration: none"
          //       href="https://doutuimao.feishu.cn/docx/JuVQdK0DToPATCxNLfLc7CNfnOg"
          //       target="_blank"
          //     >
          //       如何添加素材?
          //     </a>
          //   );
          // },
        },
        {
          defaultValue: "",
          label: "课程状态",
          Component: "el-select",
          prop: "status",
          componentProps: {
            placeholder: "请选择",
          },
          span: 14,
          on: {
            change: (value) => {
              this.$nextTick(() => {
                this.$refs.useTable.getRequestRes("firstPage");
              });
            },
          },
          childSlot: statusList.map((item) => {
            return {
              Component: "el-option",
              componentProps: {
                label: item.label,
                value: item.value,
                key: item.value,
              },
            };
          }),
        },
        {
          Component: "el-input",
          prop: "title",
          defaultValue: "",
          span: 5,
          label: "",
          componentProps: {
            placeholder: "请输入标题",
          },
        },
        {
          Component: "el-button",
          span: 2,
          componentProps: {
            type: "primary",
          },
          renderHTML: () => {
            return "查询";
          },
          on: {
            click: () => {
              this.$refs.useTable.getRequestRes("firstPage");
            },
          },
        },
      ],
    };
  },
  components: {
    useTable,
    courseInfo,
    editInventory
  },
  methods: {
    ...mapActions("xhsApis", ["getClassesListAPI", "classGroundingAPI"]),
    // 点击修改库存
    changeInventory(item){
      console.log('changeInventory-item:',item)
      this.editInventoryObj = {
        showPop: true,
        detail: item
      }
    },
    // 确认修改库存
    async sureEditInventory(){
      this.$refs.useTable.getRequestRes();
    },
    async httprequest(params) {
      console.log('httprequest-params:',params)
      delete params.pageSize
      let res = await this.getClassesListAPI(params);
      let keys = {
        data: res.list,
        total: res.page_info.total_count,
      };
      return keys;
    },
    addCourse() {
      this.$router.push(this.staticPath + "addSmallCourse");
    },
    handleTools(id, type, name, extraParams={}){
      if(type=='editCourse'){
        this.editCourse(id)
      }else if(type=='preview'){
        this.coursePreviewObj.showPop = true
      }else{
        this.centerDialogVisible = true
        this.toolsInfo = {
          id: id,
          type: type,
          name: name,
          extraParams: extraParams
        }
      }
    },
    editCourse(id) {
      // console.log(id,'editCourse----')
      this.$router.push({
        path: this.staticPath + "editSmallCourse/" + id,
      });
    },
    async handleConfrimClick(){
     this[this.toolsInfo.type]({ id: this.toolsInfo.id,...this.toolsInfo.extraParams }).then(res=>{
      this.$message({
        type: "success",
        message: `${ this.toolsInfo.name}成功`,
      });
      this.centerDialogVisible = false
      this.$refs.useTable.getRequestRes("firstPage");
     })
      
    },
  },
};
</script>
<style lang="less">
.course_status {
  .top {
    display: flex;
    .status_name {
      display: inline-block;
      width: 70px;
      height: 26px;
      border-radius: 12px;
      border: 1px solid #65ad05;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 12px;
      color: #65ad05;
      flex-shrink: 0;
      margin-right: 4px;
      &.status_name2{
        border: 1px solid #a2a2a2;
        color: #a2a2a2;
      }
    }
    .reject {
      display: inline-block;
      width: 220px;
      .reason {
        display: inline-block;
        width: 100%;
        font-size: 12px;
        color: #666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        word-break: break-all;
      }
    }
  }
  .edit_staus {
    font-size: 14px;
    color: #8e8e8e;
    margin-left: 5px;
  }
}
.button_warp {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  // flex-wrap: wrap;
  .line_button {
    min-width: 40px;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    color: #5ba8ff;
    cursor: pointer;
  }
}
</style>
